import React from 'react';
import { Link } from 'react-router-dom';
import { getTopicIconElement, getTopicSlugByKey } from '../utils/topic-utils';
import { TagGroup } from '../hooks/api/useTagGroups';
import { ROUTE_PATH } from '../routes/route-paths';

interface TopicTagProps {
  tagGroupName: string;
  icon?: React.ReactNode;
  className?: string;
  tagGroups?: TagGroup[];
}

export const TopicTag: React.FC<TopicTagProps> = ({ tagGroupName, icon, className = '', tagGroups }) => {
  // Use provided icon, or try to get icon from mapper using tag groups, or show nothing
  const tagGroup = tagGroups ? tagGroups.find((tg) => tg.name === tagGroupName) : undefined;
  const mappedIcon = icon || (tagGroup ? getTopicIconElement(tagGroup) : undefined);
  const topicSlug = tagGroup?.key ? getTopicSlugByKey(tagGroup.key) : undefined;
  const topicHref = topicSlug ? `${ROUTE_PATH.BROWSE_TOPIC}/${topicSlug}` : undefined;

  return (
    <div className={`inline-flex min-h-6 items-center justify-start gap-1.5 ${className}`}>
      {topicHref ? (
        <Link
          to={topicHref}
          className="inline-flex items-center justify-start gap-1.5 transition-opacity hover:opacity-80"
          aria-label={`Browse topic: ${tagGroupName}`}
        >
          {mappedIcon && <div className="flex h-6 w-6 shrink-0 items-center justify-center">{mappedIcon}</div>}
          <div className="font-albert-sans text-primary text-nowrap text-sm font-medium">{tagGroupName}</div>
        </Link>
      ) : (
        <>
          {mappedIcon && <div className="flex h-6 w-6 shrink-0 items-center justify-center">{mappedIcon}</div>}
          <div className="font-albert-sans text-primary text-nowrap text-sm font-medium">{tagGroupName}</div>
        </>
      )}
    </div>
  );
};
